import React from 'react';
import SelectDateField from './SelectDateField/SelectDateField';
import SelectField from './SelectField/SelectField';
import AreaField from './AreaField/AreaField';
import UploadDraggerField from './UploadDraggerField/UploadDraggerField';
import TreeCheckField from './TreeCheckField/TreeCheckField';
import InputField from './InputField/InputField';
import CheckboxField from './CheckboxField/CheckboxField';

export const fieldTypes = {
  rangePicker: 'rangePicker',
  select: 'select',
  textArea: 'textArea',
  input: 'input',
  uploadDragger: 'uploadDragger',
  treeCheckbox: 'treeCheckbox',
  checkbox: 'checkbox',
};

const Field = (props) => {
  const { fieldType, ...otherProps } = props;

  switch (fieldType) {
    case fieldTypes.rangePicker:
      return <SelectDateField {...otherProps} />;

    case fieldTypes.select:
      return <SelectField {...otherProps} />;

    case fieldTypes.textArea:
      return <AreaField {...otherProps} />;

    case fieldTypes.input:
      return <InputField {...otherProps} />;

    case fieldTypes.uploadDragger:
      return <UploadDraggerField {...otherProps} />;

    case fieldTypes.treeCheckbox:
      return <TreeCheckField {...otherProps} />;

    case fieldTypes.checkbox:
      return <CheckboxField {...otherProps} />;

    default:
      return null;
  }
};

export default Field;
